import { commaToAndFunction } from '@aca-new/app/shared/functions/strings/comma-to-and.function';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AppStringService {
  public commaToAndFunction = commaToAndFunction;
}
